const constants = {
    SIZE_LARGE: "large",
    SIZE_SMALL: "small"
};
export { constants as SIZES };
